"use strict";

var _asyncToGenerator = require("/vercel/path0/Frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _instanceof(e, t) {
  return null != t && "undefined" != typeof Symbol && t[Symbol.hasInstance] ? !!t[Symbol.hasInstance](e) : e instanceof t;
}
function _typeof(e) {
  return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  })(e);
}
function get() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "*";
  return "" === e && (e = "*"), document.querySelectorAll(e);
}
function getById() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
  return document.getElementById(e);
}
function getByCN() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
  return document.getElementsByClassName(e);
}
function getByTN() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
  return document.getElementsByTagName(e);
}
function getByN() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
  return document.getElementsByName(e);
}
function loop() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
    t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : function (e) {};
  if ("function" != typeof t) throw new Error("Expected a callback as an argument.");
  var n = 0;
  if (Array.isArray(e) || NodeList.prototype.isPrototypeOf(e) || HTMLCollection.prototype.isPrototypeOf(e)) for (n = 0; n < e.length; n++) {
    t(e[n]);
  } else {
    if ("object" !== _typeof(e) || !e) throw new Error("Expected a proper mutable iterable argument like an Array, NodeList, HTMLCollection or an Object.");
    var o = Object.keys(e);
    for (n = 0; n < o.length; n++) {
      e.hasOwnProperty(o[n]) && t(e[o[n]]);
    }
  }
}
function isElement(e) {
  return "object" === ("undefined" == typeof HTMLElement ? "undefined" : _typeof(HTMLElement)) ? _instanceof(e, HTMLElement) : e && "object" === _typeof(e) && null !== e && 1 === e.nodeType && "string" == typeof e.nodeName;
}
function HTML() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
    t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
  if ("" === t) {
    if (NodeList.prototype.isPrototypeOf(e) || HTMLCollection.prototype.isPrototypeOf(e)) {
      for (var n = [], o = 0; o < e.length; o++) {
        n.push(e[o].innerHTML);
      }
      return n;
    }
    if (isElement(e)) return e.innerHTML;
    throw new Error("Expected a NodeList, HTMLCollection or a DOM Element.");
  }
  if (NodeList.prototype.isPrototypeOf(e) || HTMLCollection.prototype.isPrototypeOf(e)) for (var r = 0; r < e.length; r++) {
    e[r].innerHTML = t;
  } else {
    if (!isElement(e)) throw new Error("Expected a NodeList, HTMLCollection or a DOM Element.");
    e.innerHTML = t;
  }
}
function TEXT() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
    t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
    n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "";
  if ("" === n) {
    if (NodeList.prototype.isPrototypeOf(e) || HTMLCollection.prototype.isPrototypeOf(e)) {
      for (var o = [], r = 0; r < e.length; r++) {
        o.push(!0 === t ? e[r].innerText : e[r].textContent);
      }
      return o;
    }
    if (isElement(e)) return !0 === t ? e.innerText : e.textContent;
    throw new Error("Expected a NodeList, HTMLCollection or a DOM Element.");
  }
  if (NodeList.prototype.isPrototypeOf(e) || HTMLCollection.prototype.isPrototypeOf(e)) for (var i = 0; i < e.length; i++) {
    !0 === t ? e[i].innerText = n : e[i].textContent = n;
  } else {
    if (!isElement(e)) throw new Error("Expected a NodeList, HTMLCollection or a DOM Element.");
    !0 === t ? e.innerText = n : e.textContent = n;
  }
}
function createEl() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
    t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  if ("string" != typeof e || "object" !== _typeof(t) || !t) throw new Error("Wrong type of argument passed.");
  try {
    for (var n = document.createElement(e), o = Object.keys(t), r = 0; r < o.length; r++) {
      t.hasOwnProperty(o[r]) && (n[o[r]] = t[o[r]]);
    }
    return n;
  } catch (e) {
    throw new Error(e);
  }
}
function appendNode(e, t) {
  if (isElement(e) && isElement(t)) return e.appendChild(t), !0;
  throw new Error("Invalid Arguments, expected DOM Nodes as parent and child.");
}
function hasClass(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
  if (isElement(e)) return e.classList.contains(t);
  throw new Error("Invalid Argument. Expected an Element.");
}
function toggleClass(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
  if (!isElement(e)) throw new Error("Invalid Argument. Expected an Element.");
  e.classList.contains(t) ? e.classList.remove(t) : e.classList.add(t);
}
function addStyles(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
    n = Object.keys(t);
  if (n.length > 0) if (NodeList.prototype.isPrototypeOf(e) || HTMLCollection.prototype.isPrototypeOf(e)) for (var o = 0; o < e.length; o++) {
    for (var r = 0; r < n.length; r++) {
      t.hasOwnProperty(n[r]) && (e[o].style[n[r]] = t[n[r]]);
    }
  } else {
    if (!isElement(e)) throw new Error("Expected a NodeList, HTMLCollection or a DOM Element.");
    for (var s = 0; s < n.length; s++) {
      t.hasOwnProperty(n[s]) && (e[i].style[n[s]] = t[n[s]]);
    }
  }
}
function AJAX() {
  return _AJAX.apply(this, arguments);
}
function _AJAX() {
  _AJAX = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var e,
      t,
      n,
      o,
      r,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            e = _args.length > 0 && void 0 !== _args[0] ? _args[0] : "GET", t = _args.length > 1 && void 0 !== _args[1] ? _args[1] : "", n = _args.length > 2 && void 0 !== _args[2] ? _args[2] : function (e) {}, o = _args.length > 3 && void 0 !== _args[3] ? _args[3] : "";
            if (!("string" != typeof t || "function" != typeof n || "string" != typeof e)) {
              _context.next = 3;
              break;
            }
            throw new Error("Invalid Arguemnt Types.");
          case 3:
            _context.prev = 3;
            if (!(!n || !e || !t)) {
              _context.next = 6;
              break;
            }
            throw new Error("URL, Type and Function required as arguments.");
          case 6:
            r = new XMLHttpRequest();
            _context.t0 = (r.open(e, t, !0), e);
            _context.next = _context.t0 === "GET" ? 10 : _context.t0 === "POST" ? 14 : _context.t0 === "PUT" ? 21 : _context.t0 === "DELETE" ? 28 : 35;
            break;
          case 10:
            r.onload = function () {
              n(r);
            };
            _context.next = 13;
            return r.send(null);
          case 13:
            return _context.abrupt("break", 36);
          case 14:
            if (o) {
              _context.next = 16;
              break;
            }
            throw new Error("Required some data to be sent through POST Request.");
          case 16:
            r.setRequestHeader("Content-type", "application/json; charset=utf-8");
            r.onload = function () {
              n(r);
            };
            _context.next = 20;
            return r.send(o);
          case 20:
            return _context.abrupt("break", 36);
          case 21:
            if (o) {
              _context.next = 23;
              break;
            }
            throw new Error("Required some data to be created through PUT Request.");
          case 23:
            r.setRequestHeader("Content-type", "application/json; charset=utf-8");
            r.onload = function () {
              n(r);
            };
            _context.next = 27;
            return r.send(o);
          case 27:
            return _context.abrupt("break", 36);
          case 28:
            if (o) {
              _context.next = 30;
              break;
            }
            throw new Error("Required some data to be created through DELETE Request.");
          case 30:
            r.setRequestHeader("Content-type", "application/json; charset=utf-8");
            r.onload = function () {
              n(r);
            };
            _context.next = 34;
            return r.send(o);
          case 34:
            return _context.abrupt("break", 36);
          case 35:
            throw new Error("Invalid Type for an XHR (or) XHR Type currently not supported.");
          case 36:
            _context.next = 41;
            break;
          case 38:
            _context.prev = 38;
            _context.t1 = _context["catch"](3);
            throw new Error(_context.t1);
          case 41:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 38]]);
  }));
  return _AJAX.apply(this, arguments);
}
function onEvent(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "click",
    n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : function (e) {};
  if (!e || !t || !n) throw new Error("All DOM Element, Event descriptor and Callback function required as arguments.");
  if (NodeList.prototype.isPrototypeOf(e) || HTMLCollection.prototype.isPrototypeOf(e)) for (var o = 0; o < e.length; o++) {
    e[o].addEventListener(t, n);
  } else {
    if (!isElement(e)) throw new Error("Invalid Argument passed as DOM Element.");
    e.addEventListener(t, n);
  }
}
function deleteEl(e) {
  if (!e) throw new Error("DOM Element or its set required as arguments.");
  if (NodeList.prototype.isPrototypeOf(e) || HTMLCollection.prototype.isPrototypeOf(e)) for (var t = 0; t < e.length; t++) {
    e[t].remove();
  } else {
    if (!isElement(e)) throw new Error("Invalid Argument passed as DOM Element.");
    e.remove();
  }
}
function clone(e) {
  if (!DOMElements) throw new Error("Expected DOM Element as argument.");
  if (isElement(e)) {
    return e;
  }
  throw new Error("Invalid DOM Element passed.");
}
function Stack() {
  return {
    stack: [],
    push: function push(e) {
      return this.stack.push(e);
    },
    peek: function peek() {
      return this.isEmpty() ? "Stack Empty." : this.stack[this.stack.length - 1];
    },
    isEmpty: function isEmpty() {
      return this.stack.length <= 0;
    },
    pop: function pop() {
      return this.stack.pop();
    },
    print: function print() {
      return this.isEmpty() ? "Stack Empty." : this.stack;
    }
  };
}
module.exports = {
  get: get,
  getByN: getByN,
  getByTN: getByTN,
  getByCN: getByCN,
  getById: getById,
  addStyles: addStyles,
  AJAX: AJAX,
  HTML: HTML,
  TEXT: TEXT,
  createEl: createEl,
  appendNode: appendNode,
  toggleClass: toggleClass,
  isElement: isElement,
  loop: loop,
  Stack: Stack,
  deleteEl: deleteEl,
  clone: clone,
  hasClass: hasClass,
  onEvent: onEvent
};